import React from 'react'
import styles from './paymentStatus.module.scss'
import { ChevronRightIcon } from '@heroicons/react/24/solid'

const paymentStatus = ({ status }) => {
	return (
		<div className={styles.paymentManageStatusDisplayWrapper}>
			<div className={styles.statusDisplayBox}>
				<span
					className={`${styles.statusLabel} ${status === '정산전' ? styles.active : ''}`}>
					정산전
				</span>
				<div className={styles.arrowWrapper}>
					<div className={styles.line}></div>
					<div
						className={`${styles.dot_1} ${status === '정산전' ? styles.activeDot : ''}`}></div>
					<ChevronRightIcon className={styles.arrowIcon_1} />
				</div>
			</div>
			<div className={styles.statusDisplayBox}>
				<span
					className={`${styles.statusLabel} ${status === '입금대기' ? styles.active : ''}`}>
					입금대기
				</span>
				<div className={styles.arrowWrapper}>
					<div className={styles.line}></div>
					<div
						className={`${styles.dot_1} ${status === '입금대기' ? styles.activeDot : ''}`}></div>
					<ChevronRightIcon className={styles.arrowIcon_1} />
				</div>
			</div>
			<div className={styles.statusDisplayBox}>
				<span
					className={`${styles.statusLabel} ${status === '입금완료' ? styles.active : ''}`}>
					입금완료
				</span>
				<div className={styles.arrowWrapper}>
					<div className={styles.line}></div>
					<div
						className={`${styles.dot_1} ${status === '입금완료' ? styles.activeDot : ''}`}></div>
					<ChevronRightIcon className={styles.arrowIcon_1} />
				</div>
			</div>
			<div className={styles.statusDisplayBox}>
				<span
					className={`${styles.statusLabel} ${status === '지급완료' ? styles.active : ''}`}>
					지급완료
				</span>
				<div className={styles.arrowWrapper}>
					<div className={styles.line}></div>
					<div
						className={`${styles.dot_1} ${status === '지급완료' ? styles.activeDot : ''}`}></div>
				</div>
			</div>
		</div>
	)
}

export default paymentStatus
